import {isInteger, parseNumber} from '../../lib/utils'

export default {
  data() {
    return {
      participantsCountStepNumber: 1,
      hoursStepNumber: 2,
      dateSelectionStepNumber: 3,
      personalDetailsStepNumber: 4,
      pricingSummaryStepNumber: 5,
    }
  },
  computed: {
    disabled() {
      return this.termsAgreed !== 'yes'
    },
    disabledOtherThanRacers() {
      return this.disabled || this.isGroupEventDetected
    },
    participantsNotSet() {
      const count = parseNumber(this.totalPlayers)
      return !isInteger(count, 1) ||
        count > this.racersLimit
    },
    racerNotSet() {
      return this.disabledOtherThanRacers ||
        this.participantsNotSet
    },
    isRaceTypeSet() {
      return !this.racerNotSet && this.raceType
    },
    isHoursNotSet() {
      return this.racerNotSet ||
        this.moreThanHoursLimit ||
        !parseNumber(this.numberOfHours) ||
        !isInteger(this.numHours, 1)
    },
    dateNotSelected() {
      return this.isHoursNotSet || !this.selectedDate
    },
    showTimeslotInputs() {
      return !this.dateNotSelected
    },
    showTimeslotInfo() {
      return this.showTimeslotInputs &&  !_.isEmpty(this.retrievedTimeslots)
    },
    showMiniCart() {
      return this.showTimeslotInputs && !!parseNumber(this.numberOfRaces)
    },
    notAllRacersSlotted() {
      return this.totalRacesSlotted < parseNumber(this.numberOfAdultRaces)
    },
    cartNotReady() {
      return this.isPersonalDetailsInvalid ||
        !this.showMiniCart ||
        this.isAnyProcessing() ||
        this.notAllRacersSlotted
    },
    disabledPersonalDetails() {
      return this.isHoursNotSet
    }
  }
}
